export const handicapList = [
  '平手', '平/半', '半球', '半/一', '一球', '一/半', '球半', '球半/二', '二球', '二/半', '二半', '二半/三', '三球', '三/半', '三半', '三半/四', '四球', '四/半', '四半', '四半/五', '五球', '五/五半', '五半', '五半/六', '六球', '六/六半', '六半', '六半/七', '七球', '七/七半', '七半', '七半/八', '八球', '八/八半', '八半', '八半/九', '九球', '九/九半', '九半', '九半/十', '十球', '十/十半', '十半', '十半/十一', '十一球', '十一/十一半', '十一半', '十一半/十二球', '十二球', '十二/十二半', '十二半', '十二半/十三球', '十三球', '十三/十三半', '十三半', '十三半/十四球', '十四球', '十四/十四半', '十四半', '十四半/十五球', '十五球', '十五/十五半', '十五半', '十五半/十六球', '十六球', '十六/十六半', '十六半', '十六半/十七球', '十七球', '十七/十七半', '十七半', '十七半/十八球', '十八球', '十八/十八半', '十八半', '十八半/十九球', '十九球', '十九/十九半', '十九半', '十九半/二十球', '二十球'
]
export const common = {
  previousStep: '上一輪',
  nextStep: '下一輪',
  close: '關閉',
  notFoundText: '抱歉，您找的頁面不存在',
  euro: '歐元',
  dollar: '美元',
  pound: '英鎊',
  rmb: '人民幣',
  cancel: '取消',
  mounth: '月份'
}
export const noticeView = {
  loading: '加載中...',
  netError: '網絡錯誤',
  noData: '沒有數據',
  refreshBtnTitle: '點擊刷新'
}
export const integral = {
  rank: '排名',
  teamName: '球隊',
  scene: '場次',
  result: '勝/平/負',
  gainAndLoss: '得/失',
  integral: '積分',
  leagueFormat: '賽制說明'
}
export const btnList = {
  schedule: '賽程',
  integral: '積分表',
  playerList: '球員榜',
  oddsStatistics: '盤路統計'
}
export const integralBtnList = {
  totalIntegral: '總積分',
  homeIntegral: '主場積分',
  guestIntegral: '客場積分'
}
export const players = {
  shooters: '射手榜',
  own: '烏龍',
  yellowCard: '黃牌',
  redCard: '紅牌',
  showAll: '查看全部',
  rank: '排名',
  player: '球員',
  teamName: '球隊',
  total: '總計'
}
export const oddsStatistics = {
  totalCourt: '總場數',
  homeCourt: '主場',
  guestCourt: '客場',
  matchCount: '賽',
  hasOdds: '開',
  han: '上',
  winAndLoss: '贏/走/輸',
  goalDifference: '淨勝',
  winningRate: '贏盤率',
  dataStatistics: '盤路數據統計',
  winMost: '贏盤之最',
  homeWin: '主場贏盤',
  draw: '和局走水',
  guestWin: '客場贏盤',
  site: '場',
  btnWin: '贏盤',
  btnDraw: '走水',
  winRate: '贏盤率'
}
export const scheduleNotesTitle = {
  halfCourt: '半場',
  fullHalf: '全/半',
  singleAndDouble: '單雙',
  letBall: '讓球',
  runTitle: '第',
  runTitle1: '輪'
}
export const playerIndex = {
  height: '身高',
  bodyWeight: '體重',
  worth: '身價',
  playerInfo: '球員信息',
  playerStats: '數據統計',
  playerPosition: '位置',
  jerseyNumber: '俱樂部球衣號',
  numberName: '號',
  ouYuan: '歐元',
  meiYuan: '美元',
  yingBang: '英鎊',
  renMinBi: '人民幣',
  wan: '萬'
}
export const playerInfo = {
  playingTeam: '效力球隊',
  playerHonor: '球員榮譽',
  playerProfile: '球員簡介',
  currentTeam: '所屬球隊',
  joinTime: '加盟時間',
  salary: '薪金',
  formerTeam: '前效力球隊',
  previousTeam: '曾效力球隊',
  transferFee: '轉會費'
}
export const teamIndex = {
  founded: '成立',
  officialWebsite: '官網',
  fixture: '賽程',
  trackRecord: '往績',
  stats: '數據',
  lineUp: '陣容',
  playerList: '球員榜',
  info: '資料',
  transfer: '轉會',
  totalPrice: '總身價',
  record: '近期戰績',
  win: '勝',
  draw: '平',
  loss: '負'
}
export const dataStatistics = {
  twoYearData: '近2年比賽數據',
  jinQiu: '進球',
  dianQiu: '點球',
  wuLong: '烏龍',
  huangPai: '黃牌',
  hongPai: '紅牌',
  duiZhen: '對陣'
}
export const teamTrackRecord = {
  confrontationRecordTitle: '近20場交鋒',
  latelyHandicap: '近20場開盤',
  win: '勝',
  win1: '贏',
  draw: '平',
  draw1: '走',
  lose: '負',
  lose1: '輸',
  winRatio: '勝率',
  payoutWinRatio: '贏率',
  overRatio: '大分率',
  singleDigitRatio: '單率',
  sectionTitle: '近20場',
  home: '主',
  away: '客',
  neutralCourt: '中',
  homeWin: '主勝',
  homeDraw: '主平',
  homeLose: '主負',
  game: '場',
  over: '大',
  halfOver: '半場大',
  under: '小',
  halfUnder: '半場小',
  single: '單',
  double: '雙'
}
export const teamTransfer = {
  zhuanRu: '轉入',
  zhuanChu: '轉出'
}
export const stats = {
  total: '總',
  home: '主',
  neutralCourt: '中',
  away: '客',
  goalDifferenceTitle: '凈勝球統計（場數）',
  goalDifference: '凈勝',
  draw: '平',
  netNegative: '凈負',
  goalTitle: '進球數統計（場數）',
  goalCount: '進球數',
  handicapTitle: '上下盤統計',
  homeHandicap: '上盤',
  drawHandicap: '平盤',
  guestHandicap: '下盤',
  win1: '贏',
  draw1: '走',
  lose1: '輸',
  goalStatsTitle: '入球數統計（場數）',
  ball: '球',
  single: '單數',
  double: '雙數'
}
export const lineUp = {
  coach: '教練',
  forward: '前鋒',
  centerForward: '中場',
  guard: '後衛',
  goalkeeper: '守門員',
  numberTitle: '號'
}
export const coach = {
  sg_tz: '身高/體重',
  renJiaoQiuHui: '任教球隊',
  xianShuQiuDui: '現屬球隊',
  qianDuQiuDui: '前度球隊',
  cengXiaoLiQiuDui: '曾效力球隊',
  qiuYuanRongYu: '球員榮譽',
  jieShao: '简介',
  shengRi: '生日',
  guoJi: '國籍'
}
export const teamInfo = {
  basicInfo: '基本信息',
  city: '所在城市',
  homeCourt: '球場',
  capacity: '球場容量',
  address: '聯系地址',
  honour: '球隊榮譽',
  summary: '球隊簡介'
}
